var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"max-height":"100vh !important","overflow-y":"hidden"},attrs:{"id":"cardDetailsInviteProcessor"}},[(_vm.providerTypeId === 1)?[_c('sumup-widget',{attrs:{"checkout-id":_vm.providerReference},model:{value:(_vm.widgetStatus),callback:function ($$v) {_vm.widgetStatus=$$v},expression:"widgetStatus"}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }